// import {getLotteryChildData, getOddsData, getNewLotteryRes} from '../../../service/lottery';

import * as gd_ha10 from '../gd_ha10/store';

// 三个类型的玩法一致,直接引用 gd_ha10 数据，维护一套接口

export const state = {
  page: 'cc_ssc',
  ...gd_ha10.state
};

export const actions = {
  ...gd_ha10.actions
};

export const mutations = {
  ...gd_ha10.mutations
};

export const getters = {
  ...gd_ha10.getters
};



// WEBPACK FOOTER //
// ./src/pages/home/cc_ssc/store.js